import React from "react";
import { FileText, Layers } from "lucide-react";

export const PlayerKbl = ({ docs }) => (
  <section data-testid="player-step-kbl">
    <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
      {docs.length} documentos · {docs.reduce((n, d) => n + (d.chunks || 0), 0)} fragmentos indexados para búsqueda
    </p>
    <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {docs.map((d) => (
        <article key={d.filename} className="flex flex-col border border-slate-200 bg-white p-5" data-testid="player-kbl-doc">
          <p className="flex items-start gap-2 font-display text-base text-slate-900">
            <FileText className="mt-1 h-3.5 w-3.5 shrink-0 text-accent-blue" /> {d.filename.replace(/\.txt$/, "")}
          </p>
          <span className="mt-2 w-fit border border-teal-700/40 bg-teal-50 px-2 py-0.5 text-[10px] uppercase tracking-[0.1em] text-teal-800">
            {d.department}
          </span>
          <p className="mt-3 flex-1 text-xs leading-relaxed text-slate-600">{d.excerpt}</p>
          <p className="mt-4 flex items-center gap-1.5 text-[10px] uppercase tracking-[0.16em] text-slate-400">
            <Layers className="h-3 w-3" /> {d.chunks} fragmentos · {(d.chars / 1000).toFixed(1)}k caracteres
          </p>
        </article>
      ))}
    </div>
  </section>
);
